const sessions = [
  {
    label: '3',
    value: '3',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '12',
    value: '12',
  },
  {
    label: 'Assessment Only',
    value: '0',
  },
];

export default sessions;
